// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogContact_dialogContact_1O6me"};